<template>
    <div class="hidden-xl hidden-lg toolbar tabbar tabbar-labels toolbar-bottom menubar-area">
        <div class="toolbar-inner">
            <a v-on:click="$root.go('Inicio')" v-bind:class="{'active': $root.$route.name == 'Inicio'}" class="tab-link">
                <img class="icone-toolbar" v-if="$root.$route.name == 'Inicio'" src="static/images/icons/home-active.png" alt="">
                <img class="icone-toolbar" v-if="$root.$route.name != 'Inicio'" src="static/images/icons/home.png" alt="">
            </a>
            <a v-if="$root.user.tipo != 'empresa'" v-on:click="$root.go('Pedidos')" v-bind:class="{'active': $root.$route.name == 'Pedidos'}" class="tab-link">
                <img class="icone-toolbar" v-if="$root.$route.name == 'Pedidos'" src="static/images/icons/calendar-active.png" alt="">
                <img class="icone-toolbar" v-if="$root.$route.name != 'Pedidos'" src="static/images/icons/calendar.png" alt="">
            </a>
            <a v-if="$root.user.tipo == 'prestador' && !$root.user.empresaCod" v-on:click="$root.go('Agendas')" v-bind:class="{'active': $root.$route.name == 'Agendas'}" class="tab-link">
                <img class="icone-toolbar" v-if="$root.$route.name == 'Agendas'" src="static/images/icons/settings-active.png" alt="">
                <img class="icone-toolbar" v-if="$root.$route.name != 'Agendas'" src="static/images/icons/settings.png" alt="">
            </a>
            <a v-on:click="$root.go('Conta')" v-bind:class="{'active': $root.$route.name == 'Conta'}" class="tab-link">
                <img class="icone-toolbar" v-if="$root.$route.name == 'Conta'" src="static/images/icons/profile-active.png" alt="">
                <img class="icone-toolbar" v-if="$root.$route.name != 'Conta'" src="static/images/icons/profile.png" alt="">
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Toolbar',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .icone-toolbar {
        height: auto;
        width: 30px;
        z-index: 1;
        transition: all 400ms ease-in-out;
    }

    .tab-link.active .icone-toolbar {
        filter: invert(59%) sepia(33%) saturate(193%) hue-rotate(179deg) brightness(96%) contrast(90%);
        -webkit-filter: invert(59%) sepia(33%) saturate(193%) hue-rotate(179deg) brightness(96%) contrast(90%);
    }
</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue